var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bet-voice"},[_c('audio',{ref:"msg",attrs:{"id":"bgm","hidden":"","src":require('@/assets/music/msg.mp3')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }